import { FC, ReactNode } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'

import s from './styles.module.scss'

interface Props {
  children: ReactNode
  icon?: AllIcons
  iconColor?: string
}

export const RouteInfoAlert: FC<Props> = ({
  children,
  icon = AllIcons.INFO_TRIANGLE,
  iconColor,
}) => {
  return (
    <div className={s.container}>
      <AppIcon
        id={icon}
        width={18}
        height={18}
        className={s.icon}
        color={iconColor}
      />
      <p className={clsx('bold-12', s.title)}>{children}</p>
    </div>
  )
}
